import get from 'lodash/get';
import qs from 'qs';

import { getEnvFromHostname, ENVIRONMENTS } from 'pages/utils/getEnvFromHostname';

class Qualtrics {
  init() {
    // Do not load Qualtrics if it's already loaded,
    // or if we are in Stencil's Retail Manager.
    if (window.QSI || window.isGriffin()) {
      return;
    }

    // Set Qualtrics intercept ID.
    const zid = 'es2krbN1CSBzYYC';
    const domain = 'lightspeedhq';
    // It would be complex to maintain a separate Qualtrics project for non-production environment.
    // We will instead use the same project for all environments and pass a flag to identify production data.
    const isProductionEnvironment = getEnvFromHostname() === ENVIRONMENTS.PRODUCTION;

    // Create root element for Qualtrics to use.
    const rootEl = window.document.createElement('div');
    rootEl.setAttribute('id', `ZN_${zid}`);
    window.document.body.appendChild(rootEl);

    // Qualtrics initialization script
    /* eslint-disable */
    // prettier-ignore
    (function(){var g=function(e,h,f,g){
      this.get=function(a){for(var a=a+"=",c=document.cookie.split(";"),b=0,e=c.length;b<e;b++){for(var d=c[b];" "==d.charAt(0);)d=d.substring(1,d.length);if(0==d.indexOf(a))return d.substring(a.length,d.length)}return null};
      this.set=function(a,c){var b="",b=new Date;b.setTime(b.getTime()+6048E5);b="; expires="+b.toGMTString();document.cookie=a+"="+c+b+"; path=/; "};
      this.check=function(){var a=this.get(f);if(a)a=a.split(":");else if(100!=e)"v"==h&&(e=Math.random()>=e/100?0:100),a=[h,e,0],this.set(f,a.join(":"));else return!0;var c=a[1];if(100==c)return!0;switch(a[0]){case "v":return!1;case "r":return c=a[2]%Math.floor(100/c),a[2]++,this.set(f,a.join(":")),!c}return!0};
      this.go=function(){if(this.check()){var a=document.createElement("script");a.type="text/javascript";a.src=g;document.body&&document.body.appendChild(a)}};
      this.start=function(){var t=this;"complete"!==document.readyState?window.addEventListener?window.addEventListener("load",function(){t.go()},!1):window.attachEvent&&window.attachEvent("onload",function(){t.go()}):t.go()};};
      try{(new g(100,"r",`QSI_S_ZN_${zid}`,`https://zn${zid}-${domain}.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_${zid}`)).start()}catch(i){}})();
    /* eslint-enable */

    // Bootstrap Qualtrics session
    window.merchantos.session.init().done(() => {
      // If Zendesk chat session is in progress or if we are on the sales register,
      // exit and prevent survey prompt.
      if (
        localStorage.getItem('ZENDESK_CHAT_SESSION') ||
        window.location.pathname === '/register.php'
      ) {
        return;
      }

      const session = window.merchantos.session.sessData || {};
      const {
        systemCustomerID: accountID,
        systemUserID: userID,
        systemCustomerCreateDate: accountCreateDate,
        systemCustomerName: accountName,
      } = session;
      const { firstName, lastName, email, employeeID, role, createDate } = session.Employee;
      const { name: shopName } = session.Shop;
      const countryCode = get(window.merchantos, 'locale.country_code');

      const urlParams = qs.parse(window.location.search, { ignoreQueryPrefix: true }) || {};
      const { name: urlName, form_name: urlFormName, tab: urlTab } = urlParams;

      // In order to display the survey form regardless of the conditions in Qualtrics, set isTest to true
      // by passing `&qualtrics_test=true` as a url param.
      const isTest = !!urlParams.qualtrics_test;

      window.LIGHTSPEEDHQ_QUALTRICS_ATTRIBUTES = {
        user_id: userID,
        account_id: accountID,
        employee_id: employeeID,
        account_employee_id: `${accountID}-${employeeID}`,
        first_name: firstName,
        last_name: lastName,
        email,
        role,
        is_owner: window.merchantos.session.hasRight('owner'),
        is_admin: window.merchantos.session.hasRight('admin'),
        employee_create_date: createDate,
        account_create_date: accountCreateDate,
        account_name: accountName,
        shop_name: shopName,
        country_code: countryCode,
        url_name: urlName,
        url_form_name: urlFormName,
        url_tab: urlTab,
        is_production_environment: isProductionEnvironment,
        is_test: isTest,
      };
    });
  }
}

export default new Qualtrics();
